<template>
  <div
    class="empty-area position-relative"
    :style="{
      minHeight: defaultHeight ? defaultHeight : 'none',
      minWidth: defaultWidth ? defaultWidth : 'none',
    }"
  >
    <span class="area-name">
      {{ areaName }}
    </span>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    areaName: {
      type: String,
      required: true,
    },
    defaultHeight: {
      type: String,
      default: '200px',
    },
    defaultWidth: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
  },
  mounted() {
  },
  methods: {
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
  },
  setup() {
  },
}
</script>

<style lang="scss" scoped>
.empty-area {
  position: relative;
  border: 2px dashed #7e7e7e;
  height: 100%;
  max-width: 100%;
}
.area-name {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 36px;
  font-weight: 700;
  color: var(--text-color);
  white-space: nowrap;
  text-align: center;
  @media screen and (max-width:767px) {
    font-size: 24px;
  }
  @media screen and (max-width:575px) {
    font-size: 18px;
  }
}
</style>
